import styled from 'styled-components'

interface DateProps {
  type: string
  name: string
  placeholder: string
  value?: any
  onChange?: any
}

const DateWrapper = styled.div`
  /* width: 510px; */
  /* padding-left: 30px; */
`

const DateInput = styled.input`
  height: 45px;
  width: 90%;
  border-radius: 10px;
  outline: none;
  padding: 0 10px;
  font-family: ${({ theme }) => theme.fontFamily.interSemiBold};
`

const DatePicker = ({
  type,
  name,
  placeholder,
  value,
  onChange,
}: DateProps) => {
  return (
    <DateWrapper>
      <DateInput
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </DateWrapper>
  )
}

const SavingsDateInput = styled(DateInput)`
  height: 45px;
  width: -webkit-fill-available;
  border: 1px solid #858c94;
  font-family: ${({ theme }) => theme.colors.gray};
  font-style: normal;
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSize.x5};
  color: ${({ theme }) => theme.colors.gray};
  opacity: 0.8;
  /* padding-left: 16px; */
`

export { DatePicker, SavingsDateInput }
